<script type="text/javascript">
// import urlConfig from '../../../static/js/urlConfig.js'
let MENUS = {
	// homeMenu: { name: "首页", url: "/", bShow: true, id: 2, parentId: 1, icon: "home", permission: "HOME_NAVIGATION", index: 1, scale: 1.8 },

	MaterialMenu: {
		name: "物小料",
		subName: "BOM",
		url: "/Material",
		id: 44,
		parentId: 1,
		icon: "material",
		permission: "HOME_NAVIGATION",
		index: 44,
		scale: 1.8,
		subMenu: [
			{
				name: "物料管理",
				url: "/Material/Material",
				id: 45,
				parentId: 44,
				icon: "system",
				permission: "btn_material_list",
				index: "44-1"
			}
			// { name: "BOM组装", url: "/Material/BOM", id: 46, parentId: 44, icon: "system", permission: "btn_billOfMaterials_listBomByMaterial", index: "44-2" }
		]
	},

	// ERPMaterialMenu: {
	//   name: "物小料",
	//   subName: "物料管理",
	//   url: "/Material",
	//   id: 144,
	//   parentId: 1,
	//   icon: "material",
	//   permission: "HOME_NAVIGATION",
	//   index: 144,
	//   scale: 1.8,
	//   subMenu: [
	//     {
	//       name: "物料列表",
	//       url: "/erp/iframe/441",
	//       iframeUrl: "/Product/report?programid=484a7a68-f796-4cb0-b9f7-8cfd306fef76",
	//       id: 445,
	//       parentId: 144,
	//       icon: "system",
	//       permission: "erp_product_list",
	//       index: "444-1"
	//     },
	//     {
	//       name: "物料bom",
	//       url: "/erp/iframe/442",
	//       iframeUrl: "/Product/report?programid=e0225ce8-859b-451d-85d7-fed48eb29beb",
	//       id: 446,
	//       parentId: 144,
	//       icon: "system",
	//       permission: "erp_bom_list",
	//       index: "444-2"
	//     },
	//     {
	//       name: "物料类别",
	//       url: "/erp/iframe/446",
	//       iframeUrl: "/Product/report?programid=8e79becb-9074-4022-b18c-2644f286092e",
	//       id: 446,
	//       parentId: 144,
	//       icon: "system",
	//       permission: "erp_product_type",
	//       index: "444-3"
	//     },
	//     {
	//       name: "物料单位",
	//       url: "/erp/iframe/447",
	//       iframeUrl: "/Product/report?programid=9b2ae6fd-9fd9-49bd-b583-df9bf59b0c3d",
	//       id: 447,
	//       parentId: 144,
	//       icon: "system",
	//       permission: "erp_product_unit",
	//       index: "444-4"
	//     },
	//     {
	//       name: "物品自由项",
	//       url: "/erp/iframe/448",
	//       iframeUrl: "/Product/report?programid=f2227a86-2f7a-42eb-b7f1-743e2947f6e5",
	//       id: 448,
	//       parentId: 144,
	//       icon: "system",
	//       permission: "erp_product_extend",
	//       index: "444-5"
	//     },
	//     {
	//       name: "模具记录单",
	//       url: "/erp/iframe/449",
	//       iframeUrl: "/Product/report?programid=0cde3afd-0147-4302-be52-ab0984d61a97",
	//       id: 449,
	//       parentId: 144,
	//       icon: "system",
	//       permission: "erp_mold_ticket",
	//       index: "444-6"
	//     }
	//   ]
	// },

	// ERPPurchasingMenu: {
	//   name: "采购",
	//   subName: "采购管理",
	//   url: "/Purchasing",
	//   id: 2144,
	//   parentId: 1,
	//   icon: "machineInterconnection",
	//   permission: "HOME_NAVIGATION",
	//   index: 2144,
	//   scale: 1.8,
	//   subMenu: [
	//     {
	//       name: "供应商管理",
	//       url: "/erp/iframe/451",
	//       iframeUrl: "/Product/report?programid=8ecdd780-77a5-4701-98ea-0c51d73daf64",
	//       id: 4245,
	//       parentId: 2144,
	//       icon: "system",
	//       permission: "erp_supplier_mgmt",
	//       index: "2444-1"
	//     },
	//     {
	//       name: "采购订单",
	//       url: "/erp/iframe/452",
	//       iframeUrl: "/Product/report?programid=a0d9614b-e80b-424e-81ec-4897561f958d",
	//       id: 4246,
	//       parentId: 2144,
	//       icon: "system",
	//       permission: "erp_purchase_order_list",
	//       index: "2444-2"
	//     },
	//     {
	//       name: "采购到货",
	//       url: "/erp/iframe/453",
	//       iframeUrl: "/Product/report?programid=ef176885-1b2c-4006-b34d-7f16a8f3c160",
	//       id: 4246,
	//       parentId: 2144,
	//       icon: "system",
	//       permission: "erp_purchase_delivery",
	//       index: "2444-3"
	//     },
	//     {
	//       name: "检验方案",
	//       url: "/erp/iframe/458",
	//       iframeUrl: "/Product/report?programid=cdc4a7bd-cc44-46d0-a90e-81323b1f3168",
	//       id: 4251,
	//       parentId: 2144,
	//       icon: "system",
	//       permission: "erp_purchase_qc_config",
	//       index: "2444-8"
	//     },
	//     {
	//       name: "来料检验",
	//       url: "/erp/iframe/456",
	//       iframeUrl: "/Product/report?programid=7d1ddcb6-e674-4def-b526-903d13a2553d",
	//       id: 4249,
	//       parentId: 2144,
	//       icon: "system",
	//       permission: "erp_purchase_qc",
	//       index: "2444-6"
	//     },
	//     {
	//       name: "采购退货",
	//       url: "/erp/iframe/454",
	//       iframeUrl: "/WorkFlowRun/SubTableEdit?secondtableeditform=668da582-ed30-65d9-abec-f620295fba42",
	//       id: 4247,
	//       parentId: 2144,
	//       icon: "system",
	//       permission: "erp_purchase_return",
	//       index: "2444-4"
	//     },
	//     {
	//       name: "采购订单明细",
	//       url: "/erp/iframe/455",
	//       iframeUrl: "/Product/report?programid=eaec9d87-9766-4090-8f8c-2d70b1dacabe",
	//       id: 4248,
	//       parentId: 2144,
	//       icon: "system",
	//       permission: "erp_purchase_order_detail",
	//       index: "2444-5"
	//     }
	//     // {
	//     // 	name: "模具管理",
	//     // 	url: "/erp/iframe/457",
	//     // 	iframeUrl: "/Product/report?programid=461b587d-590d-4ef2-9d2a-63a77e1fc135",
	//     // 	id: 4250,
	//     // 	parentId: 2144,
	//     // 	icon: "system",
	//     // 	permission: "erp_mold_mgmt",
	//     // 	index: "2444-7"
	//     // },
	//   ]
	// },
	// ERPToolMenu: {
	//   name: "模具管理",
	//   url: "/erp/iframe/457",
	//   iframeUrl: "/Product/report?programid=461b587d-590d-4ef2-9d2a-63a77e1fc135",
	//   id: 222222,
	//   parentId: 1,
	//   icon: "tool",
	//   permission: "erp_mold_mgmt",
	//   index: 222222,
	//   scale: 1.8
	// },
	// ERPSalaBOM: {
	//   name: "物小艺",
	//   subName: "销售管理",
	//   url: "/TechnologyBOM",
	//   id: 772,
	//   parentId: 1,
	//   icon: "technology",
	//   permission: "HOME_NAVIGATION",
	//   index: 772,
	//   scale: 1.8,
	//   subMenu: [
	//     {
	//       name: "客户管理",
	//       url: "/erp/iframe/461",
	//       id: 745,
	//       iframeUrl: "/Product/report?programid=14b6c0a0-667c-477e-960d-f3c187658713",
	//       parentId: 772,
	//       icon: "system",
	//       permission: "erp_customer_mgmt",
	//       index: "772-3"
	//     },
	//     {
	//       name: "商标管理",
	//       url: "/erp/iframe/467",
	//       id: 748,
	//       iframeUrl: "/Product/report?programid=ace526aa-857c-4e23-93c2-48f7807145e0",
	//       parentId: 772,
	//       icon: "system",
	//       permission: "erp_trademark_mgmt",
	//       index: "772-8"
	//     },

	//     {
	//       name: "销售订单",
	//       url: "/erp/iframe/462",
	//       id: 743,
	//       iframeUrl: "/Product/report?programid=7c7c3679-e7b4-4c5c-9353-424ded59e6a9",
	//       parentId: 772,
	//       icon: "system",
	//       permission: "erp_sales_order_list",
	//       index: "772-1"
	//     },
	//     {
	//       name: "销售发货",
	//       url: "/erp/iframe/463",
	//       id: 744,
	//       iframeUrl: "/Product/report?programid=3f4d4189-7be7-4562-84d5-9518fc916e6c",
	//       parentId: 772,
	//       icon: "system",
	//       permission: "erp_sales_delivery",
	//       index: "772-2"
	//     },
	//     {
	//       name: "销售退货",
	//       url: "/erp/iframe/464",
	//       id: 746,
	//       iframeUrl: "/WorkFlowRun/SubTableEdit?secondtableeditform=66530256-e9fe-8a91-e2f5-92e35acfff50",
	//       parentId: 772,
	//       icon: "system",
	//       permission: "erp_sales_return",
	//       index: "772-1"
	//     },
	//     {
	//       name: "销售订单明细",
	//       url: "/erp/iframe/465",
	//       id: 747,
	//       iframeUrl: "/Product/report?programid=f3f3f1a6-827e-4e17-8fb9-42784d41b5c9",
	//       parentId: 772,
	//       icon: "system",
	//       permission: "erp_sales_order_detail",
	//       index: "772-2"
	//     }
	//   ]
	// },

	TechnologyBOM: {
		name: "物小艺",
		subName: "工艺管理",
		url: "/TechnologyBOM",
		id: 72,
		parentId: 1,
		icon: "technology",
		permission: "HOME_NAVIGATION",
		index: 72,
		scale: 1.8,
		subMenu: [
			{
				name: "工序/工作中心配置",
				url: "/TechnologyBOM/ProcedureMapWorkshop",
				id: 75,
				parentId: 72,
				icon: "system",
				permission: "btn_procedureConfig_listConfig",
				index: "72-3"
			},
			// { name: "工艺路线模板", url: "/TechnologyBOM/TechnologyTemplate", id: 73, parentId: 72, icon: "system", permission: "btn_technologyTemplate_list", index: "72-1" },
			{
				name: "工艺BOM",
				url: "/TechnologyBOM/Technology",
				id: 74,
				parentId: 72,
				icon: "system",
				permission: "btn_technology_list",
				index: "72-2"
			}
		]
	},

	productionMenu: {
		name: "物小造",
		subName: "生产管理",
		url: "/Production",
		id: 5,
		parentId: 1,
		icon: "production",
		permission: "HOME_NAVIGATION",
		index: 4,
		scale: 1.8,
		subMenu: [
			// { name: "主计划管理", url: "/Production/SalesOrder", id: 121, parentId: 5, icon: "system", permission: "btn_order_listBusinessOrder", index: "4-10" },
			{
				name: "生产任务",
				url: "/ProductionTask",
				id: 118,
				parentId: 5,
				icon: "system",
				permission: "btn_productionTask_list",
				index: "4-2"
			}
			// { name: "报工核查", url: "/Production/TaskAudit", id: 618, parentId: 5, icon: "system", permission: "btn_businessOrderDispatch_listBusinessOrderDispatch", index: "4-118" },
			// { name: "批量完工", url: "/Production/CompleteTask", id: 617, parentId: 5, icon: "system", permission: "btn_businessOrderDispatch_listBusinessOrderDispatch", index: "4-116" },
			// {name: "派工单", url: "/Production/DispatchTask", id: 67, parentId: 5, icon: 'system', permission: 'btn_businessOrderDispatch_listBusinessOrderDispatch',index:'4-16'},
			// {name: "采购管理", url: "/Production/PurchaseCenter", id: 66, parentId: 5, icon: 'system', permission: 'btn_purchase_listPurchase',index:'4-9'},
			// { name: "自定义流转卡", url: "/Production/CustomPrint", id: 408, parentId: 5, icon: "system", permission: "btn_order_listBusinessOrder", index: "4-16" },
			// { name: "设备负荷", url: "/Production/DeviceGantt", id: 65, parentId: 5, icon: "system", permission: "btn_gantt_getDevice", index: "4-8" },
			// { name: "其他任务", url: "/Rework/OtherRecord", id: 190, parentId: 5, icon: "system", permission: "btn_other_task_list", index: "41-14" },
			// { name: "执行组绩效核查", url: "/Rework/PerformanceInspect", id: 191, parentId: 5, icon: "system", permission: "btn_production_plan_detail_execution_group_list", index: "41-15" }
		]
	},

	// ReworkMenu: {
	//   name: "物小返",
	//   subName: "返工管理",
	//   url: "/Rework",
	//   id: 555,
	//   parentId: 1,
	//   icon: "report",
	//   permission: "HOME_NAVIGATION",
	//   index: 41,
	//   scale: 1.8,
	//   subMenu: [
	//     { name: "返工工艺", url: "/Rework/ReworkTechnology", id: 188, parentId: 555, icon: "system", permission: "btn_reworkPlan_listReworkPlan", index: "41-1" },
	//     { name: "返工任务", url: "/Rework/ReworkTask", id: 161, parentId: 555, icon: "system", permission: "btn_reworkPlan_listReworkPlan", index: "41-12" },
	//     { name: "返工记录", url: "/Rework/ReworkRecord", id: 189, parentId: 555, icon: "system", permission: "btn_reworkRecord_list", index: "41-13" }
	//   ]
	// },

	messageMenu: {
		name: "物小检",
		subName: "质量管理",
		url: "/Quality",
		id: 7,
		parentId: 1,
		icon: "quality",
		permission: "HOME_NAVIGATION",
		index: 6,
		scale: 1.8,
		subMenu: [
			{
				name: "不合格原因",
				url: "/Quality/ErrConf",
				id: 3401,
				parentId: 7,
				icon: "system",
				permission: "btn_qcError_list",
				index: "6-5"
			},
			{
				name: "项目配置",
				url: "/Quality/QualityItem",
				id: 340,
				parentId: 7,
				icon: "system",
				permission: "btn_qcItemConfig_list",
				index: "6-4"
			},
			// { name: "质检模板配置", url: "/Quality/QualityConf", id: 39, parentId: 7, icon: "system", permission: "btn_qcTemp_list", index: "6-1" },
			{
				name: "质检方案",
				url: "/Quality/QualityPrint",
				id: 41,
				parentId: 7,
				icon: "system",
				permission: "btn_qcScheme_listQcScheme",
				index: "6-3"
			},
			{
				name: "质检任务",
				url: "/Quality/Quality",
				id: 40,
				parentId: 7,
				icon: "system",
				permission: "btn_qcTask_list",
				index: "6-2"
			}
			// {name: "质检报表", url: "/Quality/QcReport", id: 340, parentId: 7, icon: 'system', permission: 'btn_qcTask_collectQcItems',index:"6-3"},
		]
	},

	deviceCareMenu: {
		name: "物小保",
		subName: "设备管理",
		url: "/DeviceCare",
		id: 15,
		parentId: 1,
		icon: "device",
		permission: "HOME_NAVIGATION",
		index: 15,
		scale: 1.8,
		subMenu: [
			{
				name: "设备台账",
				url: "/DeviceCare/DeviceMgt",
				id: 16,
				parentId: 15,
				icon: "system",
				permission: "btn_device_listDeviceMgt",
				index: "15-6"
			},
			{
				name: "维修任务",
				url: "/DeviceCare/Repair",
				id: 25,
				parentId: 15,
				icon: "system",
				permission: "btn_repair_order_list_page",
				index: "15-5"
			},
			{
				name: "设备零件预警",
				url: "/DeviceCare/PartsWaring",
				id: 22,
				parentId: 15,
				icon: "system",
				permission: "btn_replacePart_alarm_Query",
				index: "15-8"
			}
		]
	},

	orderMenu: {
		name: "物小养",
		subName: "保养管理",
		url: "/Order",
		id: 102,
		parentId: 1,
		icon: "order",
		permission: "HOME_NAVIGATION",
		index: 102,
		scale: 1.8,
		subMenu: [
			{
				name: "保养模板",
				url: "/Order/Tep",
				id: 1023,
				parentId: 102,
				icon: "system",
				permission: "btn_maintenance_template_page",
				index: "102-3"
			},
			{
				name: "保养计划",
				url: "/Order/Plan",
				id: 1021,
				parentId: 102,
				icon: "system",
				permission: "btn_maintenance_schedule_page",
				index: "102-1"
			},
			{
				name: "保养任务",
				url: "/Order/Task",
				id: 1022,
				parentId: 102,
				icon: "system",
				permission: "btn_maintenance_order_page",
				index: "102-2"
			}
		]
	},

	spotMenu: {
		name: "物小检",
		subName: "点检管理",
		url: "/Spot",
		id: 103,
		parentId: 1,
		icon: "spot",
		permission: "HOME_NAVIGATION",
		index: 103,
		scale: 1.8,
		subMenu: [
			{
				name: "点检模板",
				url: "/Spot/Tep",
				id: 1023,
				parentId: 103,
				icon: "system",
				permission: "btn_check_template_page",
				index: "103-3"
			},
			{
				name: "点检计划",
				url: "/Spot/Plan",
				id: 1021,
				parentId: 103,
				icon: "system",
				permission: "btn_check_schedule_page",
				index: "103-1"
			},
			{
				name: "点检任务",
				url: "/Spot/Task",
				id: 1022,
				parentId: 103,
				icon: "system",
				permission: "btn_check_order_page",
				index: "103-2"
			}
		]
	},

	// productionMenu: {
	//   name: "物小造",
	//   subName: "生产管理",
	//   url: "/Production",
	//   id: 5,
	//   parentId: 1,
	//   icon: "production",
	//   permission: "HOME_NAVIGATION",
	//   index: 4,
	//   scale: 1.8,
	//   subMenu: [
	//     { name: "主计划管理", url: "/Production/SalesOrder", id: 121, parentId: 5, icon: "system", permission: "btn_order_listBusinessOrder", index: "4-10" },
	//     { name: "生产任务", url: "/ProductionTask", id: 118, parentId: 5, icon: "system", permission: "btn_productionTask_list", index: "4-2" },
	//     { name: "报工核查", url: "/Production/TaskAudit", id: 618, parentId: 5, icon: "system", permission: "btn_businessOrderDispatch_listBusinessOrderDispatch", index: "4-118" },
	//     { name: "批量完工", url: "/Production/CompleteTask", id: 617, parentId: 5, icon: "system", permission: "btn_businessOrderDispatch_listBusinessOrderDispatch", index: "4-116" },
	//     { name: "自定义流转卡", url: "/Production/CustomPrint", id: 408, parentId: 5, icon: "system", permission: "btn_order_listBusinessOrder", index: "4-16" },
	//     { name: "设备负荷", url: "/Production/DeviceGantt", id: 65, parentId: 5, icon: "system", permission: "btn_gantt_getDevice", index: "4-8" },
	//     { name: "其他任务", url: "/Rework/OtherRecord", id: 190, parentId: 5, icon: "system", permission: "btn_other_task_list", index: "41-14" },
	//     { name: "执行组绩效核查", url: "/Rework/PerformanceInspect", id: 191, parentId: 5, icon: "system", permission: "btn_production_plan_detail_execution_group_list", index: "41-15" },
	//     { name: "挑选统计", url: "/Production/SelectionStatistics", id: 1617, parentId: 5, icon: "system", permission: "btn_select_selection_statistic", index: "4-1116" }
	//   ]
	// },

	// OutputinStorageMenu: {
	//   name: "物小仓",
	//   subName: "出入库管理",
	//   url: "/outputinStorage",
	//   id: 819,
	//   parentId: 1,
	//   icon: "stock",
	//   permission: "HOME_NAVIGATION",
	//   index: 819,
	//   scale: 1.8,
	//   subMenu: [
	//     { name: "外协发货", url: "/OutputinStorage/OutsourcedDeliver", id: 8190, parentId: 819, icon: "system", permission: "btn_external_cooperation_deliver_page", index: "819-1" },
	//     { name: "外协到货", url: "/OutputinStorage/OutsourcedArrival", id: 8191, parentId: 819, icon: "system", permission: "btn_external_cooperation_arrival_page", index: "819-2" },
	//     { name: "外协统计报表", url: "/OutputinStorage/OutsourcedReport", id: 8192, parentId: 819, icon: "system", permission: "btn_external_cooperation_report", index: "819-3" },
	//     { name: "退领料管理", url: "/OutputinStorage/ReturnMaterials", id: 8193, parentId: 819, icon: "system", permission: "btn_productionMaterialRequisition_listPage", index: "819-4" }
	//   ]
	// },

	// ERPStockBOM: {
	//   name: "物小艺",
	//   subName: "仓库管理",
	//   url: "/ERPStock",
	//   id: 872,
	//   parentId: 1,
	//   icon: "stock",
	//   permission: "HOME_NAVIGATION",
	//   index: 872,
	//   scale: 1.8,
	//   subMenu: [
	//     {
	//       name: "库位设置",
	//       url: "/erp/iframe/471",
	//       id: 745,
	//       iframeUrl: "/Product/report?programid=af2ddc6b-79e2-402c-973c-eb2634e7b616",
	//       parentId: 872,
	//       icon: "system",
	//       permission: "erp_storage_location_setting",
	//       index: "772-3"
	//     },
	//     {
	//       name: "仓库设置",
	//       url: "/erp/iframe/472",
	//       id: 743,
	//       iframeUrl: "/Product/report?programid=b1705092-787a-4121-967b-8d40669c021b",
	//       parentId: 872,
	//       icon: "system",
	//       permission: "erp_warehouse_setting",
	//       index: "772-4"
	//     },
	//     {
	//       name: "出入库类型",
	//       url: "/erp/iframe/473",
	//       id: 744,
	//       iframeUrl: "/Product/report?programid=5972b8d6-152b-493c-b665-cf2f0200ed84",
	//       parentId: 872,
	//       icon: "system",
	//       permission: "erp_entry_and_out_setting",
	//       index: "772-2"
	//     },
	//     {
	//       name: "采购入库",
	//       url: "/erp/iframe/474",
	//       id: 746,
	//       iframeUrl: "/Product/report?programid=aa44acc3-8210-476a-ac70-6cb72c6e1ec4",
	//       parentId: 872,
	//       icon: "system",
	//       permission: "erp_purchase_entry",
	//       index: "772-1"
	//     },
	//     {
	//       name: "生产领料",
	//       url: "/erp/iframe/475",
	//       id: 747,
	//       iframeUrl: "/WorkFlowRun/SubTableEdit?secondtableeditform=8b6d01b9-8192-5287-174b-87cb6478ee4b",
	//       parentId: 872,
	//       icon: "system",
	//       permission: "erp_production_out",
	//       index: "772-5"
	//     },
	//     {
	//       name: "生产退料",
	//       url: "/erp/iframe/476",
	//       id: 748,
	//       iframeUrl: "/WorkFlowRun/SubTableEdit?secondtableeditform=8217d057-06cc-2cb2-71f0-69b162203133",
	//       parentId: 872,
	//       icon: "system",
	//       permission: "erp_production_return",
	//       index: "772-6"
	//     },
	//     {
	//       name: "完工入库",
	//       url: "/erp/iframe/477",
	//       id: 749,
	//       iframeUrl: "/WorkFlowRun/SubTableEdit?secondtableeditform=fde9e36e-eb45-b12c-83b9-b22e43e5901a",
	//       parentId: 872,
	//       icon: "system",
	//       permission: "erp_production_entry",
	//       index: "772-8"
	//     },
	//     {
	//       name: "销售出库",
	//       url: "/erp/iframe/478",
	//       id: 750,
	//       iframeUrl: "/WorkFlowRun/SubTableEdit?secondtableeditform=636a6920-2240-4852-14ec-5800ce42a0cb",
	//       parentId: 872,
	//       icon: "system",
	//       permission: "erp_sales_out",
	//       index: "772-9"
	//     },
	//     {
	//       name: "库存调拨",
	//       url: "/erp/iframe/479",
	//       id: 751,
	//       iframeUrl: "/WorkFlowRun/SubTableEdit?secondtableeditform=5762cd14-69a3-478b-be85-3c49edd37feb",
	//       parentId: 872,
	//       icon: "system",
	//       permission: "erp_storage_move",
	//       index: "772-10"
	//     },
	//     {
	//       name: "其他出库",
	//       url: "/erp/iframe/480",
	//       id: 752,
	//       iframeUrl: "/WorkFlowRun/SubTableEdit?secondtableeditform=1d669edf-e9bb-f1cb-5caf-8064cbd1ba3c",
	//       parentId: 872,
	//       icon: "system",
	//       permission: "erp_other_out",
	//       index: "772-11"
	//     },
	//     {
	//       name: "其他入库",
	//       url: "/erp/iframe/481",
	//       id: 753,
	//       iframeUrl: "/WorkFlowRun/SubTableEdit?secondtableeditform=211dacd2-dd2f-46ee-b3b1-7bab1fde9dac",
	//       parentId: 872,
	//       icon: "system",
	//       permission: "erp_other_entry",
	//       index: "772-12"
	//     },
	//     {
	//       name: "库存盘点",
	//       url: "/erp/iframe/482",
	//       id: 754,
	//       iframeUrl: "/WorkFlowRun/SubTableEdit?secondtableeditform=a2767272-292d-1875-93cb-e920ed29ce2f",
	//       parentId: 872,
	//       icon: "system",
	//       permission: "erp_storage_count",
	//       index: "772-13"
	//     },
	//     {
	//       name: "出入库明细",
	//       url: "/erp/iframe/483",
	//       id: 755,
	//       iframeUrl: "/Product/report?programid=8b79b951-de16-42f7-8046-3b1419430621",
	//       parentId: 872,
	//       icon: "system",
	//       permission: "erp_entry_and_out_detail",
	//       index: "772-14"
	//     },
	//     {
	//       name: "出入库汇总",
	//       url: "/erp/iframe/484",
	//       id: 756,
	//       iframeUrl: "/Product/report?programid=3156a5f5-7388-4872-9c6c-411ce7f54968",
	//       parentId: 872,
	//       icon: "system",
	//       permission: "erp_entry_and_out_list",
	//       index: "772-15"
	//     },
	//     {
	//       name: "库存量明细",
	//       url: "/erp/iframe/485",
	//       id: 757,
	//       iframeUrl: "/Product/report?programid=c918583d-cce9-4c56-bdce-134665d4815d",
	//       parentId: 872,
	//       icon: "system",
	//       permission: "erp_storage_detail",
	//       index: "772-16"
	//     },
	//     {
	//       name: "库存量汇总",
	//       url: "/erp/iframe/486",
	//       id: 758,
	//       iframeUrl: "/Product/report?programid=cb1208d9-5c9e-468c-a2e5-84dcce4c75e3",
	//       parentId: 872,
	//       icon: "system",
	//       permission: "erp_storage_list",
	//       index: "772-17"
	//     }
	//   ]
	// },

	// toolModelMeun: {
	//   name: "物小模",
	//   subName: "模具管理",
	//   url: "/Tool",
	//   id: 114,
	//   parentId: 1,
	//   icon: "tool",
	//   permission: "HOME_NAVIGATION",
	//   index: 114,
	//   scale: 1.8,
	//   subMenu: [
	//     { name: "模具基础数据", url: "/Tool/ToolMgt", id: 115, parentId: 114, icon: "system", permission: "btn_tool_listTool", index: "114-1" },
	//     { name: "模具保养计划", url: "/Tool/ToolPlan", id: 116, parentId: 114, icon: "system", permission: "btn_tool_listTool-1", index: "114-2" },
	//     { name: "模具维保工单", url: "/Tool/ToolCare", id: 119, parentId: 114, icon: "system", permission: "btn_tool_workOrderList", index: "114-3" },
	//     { name: "模具使用维保记录", url: "/Tool/ToolRecord", id: 120, parentId: 114, icon: "system", permission: "btn_tool_listTool-2", index: "114-4" }
	//   ]
	// },

	reportMenu: {
		name: "物小秘",
		subName: "报表",
		url: "/Report",
		id: 6,
		parentId: 1,
		icon: "report",
		permission: "HOME_NAVIGATION",
		index: 5,
		scale: 1.8,
		subMenu: [
			{
				name: "生产报表",
				url: "/Report/ProductionReport",
				id: 481,
				parentId: 6,
				icon: "system",
				permission: "btn_production_menu",
				index: "5-"
			},
			// {name: "生产报表", url: "/Report/OrderReport", id: 48, parentId: 6, icon: 'system', permission: 'btn_report_workOrderProcessOutput',index:"5-3"},
			// { name: "员工报表", url: "/Report/UserReport", id: 25, parentId: 6, icon: "system", permission: "btn_report_listDispatchReport", index: "5-2" },
			// {name: "异常分析报表", url: "/Report/ExceptionReport", id: 25, parentId: 6, icon: 'system', permission: 'btn_report_listWorkerProcessCount',index:"5-3"},

			{
				name: "质检报表",
				url: "/Report/QualityReport",
				id: 41,
				parentId: 6,
				icon: "system",
				permission: "btn_maintenance_menu",
				index: "5-6"
			},
			// { name: "在制品报表", url: "/Report/WipIndex", id: 51, parentId: 6, icon: "system", permission: "btn_report_listWorkerProcessCount", index: "5-5" },
			{
				name: "设备报表",
				url: "/Report/deviceIndex",
				id: 516,
				parentId: 6,
				icon: "system",
				permission: "btn_device_menu",
				index: "5-10"
			},
			{
				name: "能耗报表",
				url: "/Report/energyIndex",
				id: 517,
				parentId: 6,
				icon: "system",
				permission: "btn_energy_menu",
				index: "5-11"
			},
			// {
			// 	name: "交接班记录表",
			// 	url: "/Report/shiftRecords",
			// 	id: 518,
			// 	parentId: 6,
			// 	icon: "system",
			// 	permission: "btn_energy_menu",
			// 	index: "5-12"
			// }
		]
	},

	boardMenu: {
		name: "物小秘",
		subName: "看板",
		url: "/board",
		id: 66,
		parentId: 1,
		icon: "board",
		permission: "HOME_NAVIGATION",
		index: 66,
		scale: 90,
		subMenu: [
			// { name: "可视化大屏", url: "/erp/iframe/888", iframeUrl: urlConfig.visualUrl, id: 4888, parentId: 66, icon: "system", permission: "btn_indexInfo_getBoard", index: "65-888" },
			{
				name: "生产订单看板",
				url: "/ProductBillboard",
				id: 107,
				parentId: 66,
				icon: "system",
				permission: "btn_board_gh_production",
				index: "65-1"
			},
			{
				name: "质量看板",
				url: "/qualityboard",
				id: 5158,
				parentId: 66,
				icon: "system",
				permission: "btn_board_gh_quality",
				index: "65-3"
			},
			{
				name: "机联看板",
				url: "/Machineboard",
				id: 108,
				parentId: 66,
				icon: "system",
				permission: "btn_board_gh_device",
				index: "65-2"
			},
			{
				name: "设备看板",
				url: "/deviceboard",
				id: 108,
				parentId: 66,
				icon: "system",
				permission: "btn_board_gh_maintenance",
				index: "65-4"
			},
			{
				name: "工艺参数实时告警",
				url: "/pointAlarmBoard",
				id: 110,
				parentId: 66,
				icon: "system",
				permission: "btn_technology_param_alarm_board",
				index: "65-4"
			},
			{
				name: "看板轮播",
				url: "/allboard",
				id: 109,
				parentId: 66,
				icon: "system",
				permission: "btn_board_gh_maintenance",
				index: "65-5"
			}

			// { name: "汇正生产看板", url: "/HuizhengProductBoard", id: 5158, parentId: 66, icon: "system", permission: "btn_production_board_1", index: "5-4156" },
			// { name: "瑞兴生产看板", url: "/RuixingProductBoard", id: 5157, parentId: 66, icon: "system", permission: "btn_production_board_2", index: "5-4157" },
			// { name: "在制品呼叫看板", url: "/WorkInProcessCallBoard", id: 559, parentId: 66, icon: "system", permission: "btn_indexInfo_getBoard", index: "65-41561" },
			// { name: "在制品看板", url: "/ProcessBoard", id: 5581, parentId: 6, icon: "system", permission: "btn_indexInfo_getBoard", index: "5-4157" },
			// { name: "生产交期监控看板", url: "/ProcessDashboard", id: 5582, parentId: 6, icon: "system", permission: "btn_indexInfo_getBoard", index: "5-4158" }
		]
	},

	// exceptionMenu: {
	//   name: "物小警",
	//   subName: "异常管理",
	//   url: "/Warning",
	//   id: 100,
	//   parentId: 1,
	//   icon: "warning",
	//   permission: "HOME_NAVIGATION",
	//   index: 100,
	//   scale: 1.8,
	//   subMenu: [
	//     { name: "事件处理配置", url: "/Warning/DealConfig", id: 201, parentId: 9, icon: "system", permission: "btn_eventProcessConfig_list", index: "100-1" },
	//     { name: "响应设置", url: "/Warning/ExceptionConfig", id: 203, parentId: 9, icon: "system", permission: "btn_anomalyResponse_list", index: "100-3" },
	//     { name: "异常清单", url: "/Warning/ExceptionList", id: 202, parentId: 9, icon: "system", permission: "btn_anomalyEvent_list", index: "100-2" },
	//     { name: "通知详情", url: "/MasterData/MessageCenter", id: 56, parentId: 15, icon: "system", permission: "btn_pushMessage_listPushMessage", index: "14-5" }
	//   ]
	// },

	collectionMenu: {
		name: "物小采",
		subName: "数据采集",
		url: "/Collection",
		id: 55,
		parentId: 1,
		icon: "machineInterconnection",
		permission: "HOME_NAVIGATION",
		index: 515,
		scale: 1.8,
		subMenu: [
			{
				name: "机联管理",
				url: "/Collection/Equipment",
				id: 303,
				parentId: 15,
				icon: "system",
				permission: "btn_device_list-page",
				index: "300-3"
			},
			// {
			//   name: "指令管理",
			//   url: "/Collection/command",
			//   id: 304,
			//   parentId: 15,
			//   icon: "system",
			//   permission: "btn_device_list-page",
			//   index: "300-4"
			// },
			{
				name: "告警清单",
				url: "/Collection/AlarmList",
				id: 301,
				parentId: 15,
				icon: "system",
				permission: "btn_alarm_his_list_page",
				index: "300-1"
			},
			{
				name: "告警设置",
				url: "/Collection/AlarmSetting",
				id: 302,
				parentId: 15,
				icon: "system",
				permission: "btn_alarm_rule_list_page",
				index: "300-2"
			},
			{
				name: "工艺参数告警",
				url: "/Collection/pointAlarm",
				id: 305,
				parentId: 15,
				icon: "system",
				permission: "btn_technology_param_alarm",
				index: "300-2"
			}
		]
	},

	// workshopMenu: {
	//   name: "物小联",
	//   subName: "机联网",
	//   url: "/MachineInterconnection",
	//   id: 55,
	//   parentId: 1,
	//   icon: "machineInterconnection",
	//   permission: "HOME_NAVIGATION",
	//   index: 55,
	//   scale: 1.8,
	//   subMenu: [{ name: "可视化机组", url: "/MachineInterconnection/WorkShop", id: 56, parentId: 55, icon: "workshop", permission: "btn_workshop_getDataModelList", index: "55-1" }]
	// },

	masterDataMenu: {
		name: "基础数据",
		subName: "基础数据",
		url: "/MasterData",
		id: 15,
		parentId: 1,
		icon: "master_data",
		permission: "HOME_NAVIGATION",
		index: 14,
		scale: 1.8,
		subMenu: [
			{
				name: "主数据配置",
				url: "/MasterData/MasterDataConfig",
				id: 47,
				parentId: 15,
				icon: "system",
				permission: "btn_masterData_listProductionType",
				index: "14-3"
			},
			{
				name: "用户管理",
				url: "/MasterData/UserMgt",
				id: 17,
				parentId: 15,
				icon: "system",
				permission: "btn_user_listUserMgt",
				index: "14-4"
			},
			// { name: "执行组管理", url: "/MasterData/UserGroup", id: 817, parentId: 15, icon: "system", permission: "btn_executionGroup_page", index: "14-4" },
			// { name: "班组管理", url: "/MasterData/TeamList", id: 91, parentId: 92, icon: "system", permission: "btn_team_page", index: "14-5" },
			{
				name: "工厂建模",
				url: "/MasterData/FactoryModel",
				id: 113,
				permission: "btn_factoryModel_listFactoryModel",
				parentId: 15,
				icon: "system",
				index: "112-1"
			},
			{
				name: "附件管理",
				url: "/MasterData/FileMgt",
				id: 66,
				parentId: 15,
				icon: "system",
				permission: "btn_fileSys_list",
				index: "14-6"
			},
			{
				name: "角色配置",
				url: "/MasterData/RoleConf",
				id: 38,
				parentId: 15,
				icon: "system",
				permission: "btn_permission_list",
				index: "14-8"
			},
			// { name: "工作日历", url: "/MasterData/workingCalendar", id: 49, parentId: 15, icon: "system", permission: "btn_calendarDate_listCalendarDateConfig", index: "14-9" },
			{
				name: "条码配置",
				url: "/MasterData/QRCodeConfig",
				id: 70,
				parentId: 15,
				icon: "system",
				permission: "btn_codeRule_listCodeRule",
				index: "14-10"
			},
			{
				name: "编码管理",
				url: "/MasterData/CodeMgt",
				id: 71,
				parentId: 15,
				icon: "system",
				permission: "btn_encode_page",
				index: "14-11"
			},
			{
				name: "字典管理",
				url: "/MasterData/Dictionary",
				id: 72,
				parentId: 15,
				icon: "system",
				permission: "btn_property_extend_list",
				index: "14-12"
			},
			{
				name: "客户管理",
				url: "/MasterData/ClientMgt",
				id: 73,
				parentId: 15,
				icon: "system",
				permission: "btn_customer_page",
				index: "14-13"
			}
		]
	}
};
//定义全局按钮权限
let PERMISSION = {
	DTU_ADD_ABLE: true
};

let RESPONSE = {
	SUCCESS: "success",
	FAIL: "fail"
};

//测试环境
const baseUrl = "http://dev.imaster.net.cn"; //全局url发布不同环境URL不同
const wsUrl = location.protocol == "https:" ? `wss://dev.imaster.net.cn` : `ws://dev.imaster.net.cn`; //全局维保socketUrl

//正式环境
// const baseUrl = 'http://wuyuan.imaster.net.cn'
// const wsUrl = (location.protocol=='https:'?`wss://wuyuan.imaster.net.cn`:`ws://wuyuan.imaster.net.cn`)

export default {
	MENUS,
	RESPONSE,
	baseUrl,
	wsUrl
};
</script>



// WEBPACK FOOTER //
// src/components/common/Global.vue